// @flow

import { type IncomingPayment } from './types';

export function getRedirectBackUrl(incomingPayment: IncomingPayment): ?string {
  if(incomingPayment.status !== 'OP')
    return null;

  if (incomingPayment.v2 && incomingPayment.v2.redirect)
    return incomingPayment['v2']['redirect']['redirect_back_url'];

  return incomingPayment['redirect_back_url'];
}
